import configJson from "../config.json";

/**
 * ConfigAdapter - Compatibilidade com config do integrar-skin
 * Mapeia o config.json do manager-cob para formato esperado pelos componentes importados
 */

// Em build de produção, mesmo servido localmente, deve usar a URL remota.
const isLocalhost =
    typeof window !== "undefined" &&
    window.location.hostname === "localhost";
const localUrl = configJson._url_integrar.replace(/\/$/, "");
const remoteUrl = configJson.url_integrar.replace(/\/$/, "");
const developmentUrl = isLocalhost
    ? localUrl
    : remoteUrl;

// Mantém o formato config[process.env.NODE_ENV].url esperado pelos consumidores
const config = {
    development: { url: developmentUrl },
    production: { url: remoteUrl },
    test: { url: remoteUrl },
};

/**
 * getBasicAuthHeaders - Gera headers com autenticação Basic Auth
 * Usada para requisições às APIs importadas do integrar-skin
 *
 * @returns {Object} Headers com Authorization Basic Auth
 * @example
 * const headers = getBasicAuthHeaders();
 * fetch(url, {
 *   method: 'GET',
 *   headers: new Headers(headers)
 * });
 */
export const getBasicAuthHeaders = () => {
    // Credenciais ofuscadas em base64
    const u = atob("Y29icmFuY2E=");
    const p = atob("Q0c1RThqckNQNg==");
    const basicAuth = "Basic " + btoa(u + ":" + p);

    return {
        Authorization: basicAuth,
        "Content-Type": "application/json",
    };
};

export default config;
